export default __webpack_public_path__ + "static/media/tempo-down.6ee7f700.svg";